import { KiamaField } from '../../../../types/kiama';
import { SuggestedAddress, AddressDetailResponse } from './AddressSearchApiTypes';

///////////////////////////////////////////////////////////////////////////////
// These are the publicly exported types. Types that are only for internal
// use should not be in here!
///////////////////////////////////////////////////////////////////////////////

export * from './AddressSearchApiTypes';

/**
 * @deprecated Please use `KiamaField` instead
 */
export type KiamaModelValue = KiamaField;

export type AutoSuggestAddressEntryMode = 'auto' | 'manual';
export type AutoSuggestAddressType = 'all' | 'mailing' | 'physical';

/**
 * The API expected by the AddressSearch component. This will be adapted to the API expected by the underlying
 * SNSW AutoSuggestAddress component.
 */
export interface AutoSuggestAddressApi {
  getSuggestions: (
    searchTerm: string,
    addressType?: AutoSuggestAddressType,
    signal?: AbortSignal
  ) => Promise<SuggestedAddress[]>;
  getDetailsById: (addressId: string) => Promise<AddressDetailResponse>;
}

/**
 * The data model supported by the SNSW component
 */
export interface AutoSuggestAddressModel {
  unitNumber?: KiamaField;
  buildingNumber?: KiamaField;
  streetNumber?: KiamaField;
  streetName?: KiamaField;
  streetType?: KiamaField;
  propertyName?: KiamaField;
  postalDeliveryType?: KiamaField;
  postalDeliveryNumber?: KiamaField;
  streetAddress?: KiamaField;
  suburb?: KiamaField;
  state?: KiamaField;
  country?: KiamaField;
  postcode?: KiamaField;
  latitude?: KiamaField<number>;
  longitude?: KiamaField<number>;
  nswPointId?: KiamaField;
  formattedAddress?: KiamaField;
  lgaName?: KiamaField;
  lgaShortName?: KiamaField;
  lgaPid?: KiamaField;
  cadastralIdentifier?: KiamaField;
  cadastralParcels?: KiamaField;
  validated?: KiamaField<boolean>;
}
